module.exports = __webpack_public_path__ + "img/d0.9c88a9b6.png";